/**
 * LaunchDarkly Feature Flag Keys
 *
 * This file contains all feature flag keys used across the application.
 * When adding a new flag, add it here to maintain a single source of truth.
 */
export const FEATURE_FLAG_KEYS = {
  COMMON: {
    SUBMISSION_REDESIGN: 'newSubmissionForm',
  },
  PM: {
    BETA_BUTTON: 'betaExternalPmPortal',
    REDESIGN: 'externalPmPages',
  },
  SP: {
    BETA_BUTTON: 'spPortalReskinBetaButton',
    REDESIGN: 'spPortalReskin',
    WORK_ORDERS_QUERY_TABLE: 'spWorkOrdersQueryTable',
  },
  ADMIN: {
    PM_BETA_BUTTON: 'betaInternalAdminPortal',
    PM_REDESIGN: 'adminPmPages',
    PM_DATA_SYNC: 'dataSyncTab',
    SP_REDESIGN: 'adminSpRedesign',
    SP_BETA_BUTTON: 'adminSpBetaButton',
  },
} as const

export type FeatureFlag = {
  [
    K in keyof typeof FEATURE_FLAG_KEYS
  ]: (typeof FEATURE_FLAG_KEYS)[K][keyof (typeof FEATURE_FLAG_KEYS)[K]]
}[keyof typeof FEATURE_FLAG_KEYS]

/**
 * Keys for beta toggles stored in localStorage
 * These could be the same or separate from the flag keys used in LaunchDarkly
 *
 * Those would be the keys passed as attributes of LD context on initialization
 */
export const BETA_TOGGLE_KEYS: { [key: string]: FeatureFlag } = {
  PM_REDESIGN: FEATURE_FLAG_KEYS.PM.BETA_BUTTON,
  SP_REDESIGN: FEATURE_FLAG_KEYS.SP.BETA_BUTTON,
  ADMIN_PM_REDESIGN: FEATURE_FLAG_KEYS.ADMIN.PM_BETA_BUTTON,
  ADMIN_SP_REDESIGN: FEATURE_FLAG_KEYS.ADMIN.SP_BETA_BUTTON,
}
